/**
 * region for libraries*/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import { Paper, Typography, TableContainer, Table, TableHead, TableRow, TableBody, TableCell, TablePagination, Tooltip } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
/**
 * region for redux*/
import { connect } from "react-redux";

/**
 * region for styles*/
import { detailIdentifySupplierJobsStyle } from "./style/detailIdentifySupplierJobsStyle";

/**
 * region for hepers*/
import Constants from "../../constants/Constants";
import typing from "../../helpers/typing";
import clsx from "clsx";
import { Skeleton } from "@material-ui/lab";
class DetailIdentifySupplierJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Constants.MODE_LOADED,
      rowsPerPage: 5,
      pageLog: 0,
      pageCategories: 0,
      pageKeywords: 0,
    };
  }

  handleOnChangePageLog = (event, newPage) => {
    const self = this;
    self.setState({
      pageLog: newPage,
    });
  };

  handleOnChangePageCategories = (event, newPage) => {
    const self = this;
    self.setState({
      pageCategories: newPage,
    });
  };

  handleOnChangePageKeywords = (event, newPage) => {
    const self = this;
    self.setState({
      pageKeywords: newPage,
    });
  };

  render() {
    let self = this;
    const { classes, selectedRow, selectedRowDetails, pending } = self.props;

    let labelStatus;
    if (Constants.SUPPLIER_JOB_STATUS.some((d) => d.id === selectedRow.IdStatus)) {
      labelStatus = Constants.SUPPLIER_JOB_STATUS.find((x) => x.id === selectedRow.IdStatus).value;
    }

    //#region Table Categories
    let tableCategoriesRows;
    let tableCategoriesTotalRows = 0;
    if (selectedRowDetails.data != null && selectedRowDetails.data.CATEGORIES != null && Object.keys(selectedRowDetails.data.CATEGORIES).length > 0) {
      tableCategoriesTotalRows = selectedRowDetails.data.CATEGORIES.length;
      tableCategoriesRows = selectedRowDetails.data.CATEGORIES.slice(
        self.state.pageCategories * self.state.rowsPerPage,
        self.state.pageCategories * self.state.rowsPerPage + self.state.rowsPerPage
      ).map((item, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="left" width={450} className={classes.tableCellLabelListItem}>
              {item.Description}
            </TableCell>
            <TableCell align="left" className={classes.tableCellLabelListItem}>
              {item.Score}
            </TableCell>
          </TableRow>
        );
      });
    }
    let tableCategoriesEmptyRows =
      self.state.rowsPerPage - Math.min(self.state.rowsPerPage, tableCategoriesTotalRows - self.state.pageCategories * self.state.rowsPerPage);
    //#endregion

    //#region Table Keywords
    let tableKeywordsRows;
    let tableKeywordsTotalRows = 0;
    if (selectedRowDetails.data != null && selectedRowDetails.data.KEYWORDS != null && Object.keys(selectedRowDetails.data.KEYWORDS).length > 0) {
      tableKeywordsTotalRows = selectedRowDetails.data.KEYWORDS.length;
      tableKeywordsRows = selectedRowDetails.data.KEYWORDS.slice(
        self.state.pageKeywords * self.state.rowsPerPage,
        self.state.pageKeywords * self.state.rowsPerPage + self.state.rowsPerPage
      ).map((item, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="left" width={450} className={classes.tableCellLabelListItem}>
              {item.Description}
            </TableCell>
            <TableCell align="left" className={classes.tableCellLabelListItem}>
              {item.Score}
            </TableCell>
          </TableRow>
        );
      });
    }
    let tableKeywordsEmptyRows =
      self.state.rowsPerPage - Math.min(self.state.rowsPerPage, tableKeywordsTotalRows - self.state.pageKeywords * self.state.rowsPerPage);
    //#endregion

  //#region Table Keywords Found
  let tableKeywordsFoundRows;
  let tableKeywordsFoundTotalRows = 0;
  if (selectedRowDetails.data != null && selectedRowDetails.data.KEYWORDSFOUND != null && Object.keys(selectedRowDetails.data.KEYWORDSFOUND).length > 0) {
    tableKeywordsFoundTotalRows = selectedRowDetails.data.KEYWORDSFOUND.length;
    tableKeywordsFoundRows = selectedRowDetails.data.KEYWORDSFOUND.map((item, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="left" width={450} className={classes.tableCellLabelListItem}>
            Researched keywords: {item.KEYWORD}
          </TableCell>
        </TableRow>
      );
    });
  }
  //#endregion



    //#region Table LOGS
    let tableLogRows;
    let tableLogTotalRows = 0;
    if (selectedRowDetails.data != null && selectedRowDetails.data.LOGS != null && Object.keys(selectedRowDetails.data.LOGS).length > 0) {
      tableLogTotalRows = selectedRowDetails.data.LOGS.length;
      tableLogRows = selectedRowDetails.data.LOGS.slice(
        self.state.pageLog * self.state.rowsPerPage,
        self.state.pageLog * self.state.rowsPerPage + self.state.rowsPerPage
      ).map((item, index) => {
        let labelStatus;
        if (Constants.SUPPLIER_JOB_TYPE.some((d) => d.id === item.IDENTIFYSUPPLIERPROCESSTYPE)) {
          labelStatus = Constants.SUPPLIER_JOB_TYPE.find((x) => x.id === item.IDENTIFYSUPPLIERPROCESSTYPE).value;
        }

        let status;
        if (Constants.SUPPLIER_JOB_STATUS.some((d) => d.id === item.IDSTATUS)) {
          status = Constants.SUPPLIER_JOB_STATUS.find((x) => x.id === item.IDSTATUS);
        }

        return (
          <TableRow key={index}>
            <TableCell align="left" className={classes.tableCellLabelBody}>
              {labelStatus}
            </TableCell>
            <TableCell align="left" className={classes.tableCellLabelBody}>
              {status && (
                <Tooltip title={status.value} aria-label={status.value} placement="right">
                  <Icon>{status.icon}</Icon>
                </Tooltip>
              )}
            </TableCell>
            <TableCell align="left" className={classes.tableCellLabelBody}>
              {item.USER}
            </TableCell>
            <TableCell align="left" className={classes.tableCellLabelBody}>
              {!typing.isEmpty(item.DATE) ? typing.convertToDateShortMonthWithTime(item.DATE) : ""}
            </TableCell>
          </TableRow>
        );
      });
    }
    let tableLogEmptyRows = self.state.rowsPerPage - Math.min(self.state.rowsPerPage, tableLogTotalRows - self.state.pageLog * self.state.rowsPerPage);
    //#endregion
    return (
      <Fragment>
        <Paper elevation={0} className={classes.paperTitle} square={true}>
          <Typography variant="h6">
            {pending && <Skeleton variant="rect" width="70%" height={32} animation="wave" />}
            {!pending && selectedRow.Domain}
          </Typography>
        </Paper>

        <Paper elevation={0} className={classes.paperTable} square={false}>
          {pending && <Skeleton variant="rect" width="100%" height={172} animation="wave" />}
          {!pending && (
            <Fragment>
              <TableContainer className={classes.tableContainer}>
                <Table className={classes.tableDetails} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className={classes.tableCellLabelHeaderTitle}>
                        Crawl information
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" className={clsx(classes.tableCellLabelHeaderSubtitleDetails, classes.tableCellLabelHeaderAndBodyDetails270)}>
                        Company Name
                      </TableCell>
                      <TableCell align="left" className={clsx(classes.tableCellLabelHeaderSubtitleDetails, classes.tableCellLabelHeaderAndBodyDetails270)}>
                        Location
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left" className={clsx(classes.tableCellLabelBodyDetails, classes.tableCellLabelHeaderAndBodyDetails270)}>
                        {selectedRow.Company}
                      </TableCell>
                      <TableCell align="left" className={clsx(classes.tableCellLabelBodyDetails, classes.tableCellLabelHeaderAndBodyDetails270)}>
                        {selectedRow.Location}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer className={classes.tableContainer}>
                <Table className={classes.tableDetails} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className={clsx(classes.tableCellLabelHeaderSubtitleDetails, classes.tableCellLabelHeaderAndBodyDetails108)}>
                        Date
                      </TableCell>
                      <TableCell align="left" className={clsx(classes.tableCellLabelHeaderSubtitleDetails, classes.tableCellLabelHeaderAndBodyDetails108)}>
                        Status
                      </TableCell>
                      <TableCell align="left" className={clsx(classes.tableCellLabelHeaderSubtitleDetails, classes.tableCellLabelHeaderAndBodyDetails108)}>
                        Users
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>                   
                      <TableCell align="left" className={clsx(classes.tableCellLabelBodyDetails, classes.tableCellLabelHeaderAndBodyDetails108)}>
                        {!typing.isEmpty(selectedRow.EndDate) ? typing.convertToDateShortMonth(selectedRow.EndDate) : ""}
                      </TableCell>
                      <TableCell align="left" className={clsx(classes.tableCellLabelBodyDetails, classes.tableCellLabelHeaderAndBodyDetails108)}>
                        {labelStatus}
                      </TableCell>
                      <TableCell align="left" className={clsx(classes.tableCellLabelBodyDetails, classes.tableCellLabelHeaderAndBodyDetails108)}>
                        {selectedRow.CounterContactPersons}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Fragment>
          )}
        </Paper>

        {tableCategoriesTotalRows > 0 && (
          <Paper elevation={0} className={classes.paperTable} square={false}>
            {pending && <Skeleton variant="rect" width="100%" height={118} animation="wave" />}
            {!pending && tableCategoriesTotalRows > 0 && (
              <Fragment>
                <TableContainer className={classes.tableContainer}>
                  <Table className={classes.tableDetails} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" colSpan={2} className={classes.tableCellLabelHeaderTitle}>
                          Categories
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" className={classes.tableCellLabelHeaderSubtitleDetails}>
                          Category
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellLabelHeaderSubtitleDetails}>
                          Score
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableCategoriesTotalRows > 0 && <Fragment>{tableCategoriesRows}</Fragment>}
                      {tableCategoriesTotalRows > 0 && tableCategoriesEmptyRows > 0 && (
                        <TableRow style={{ height: 18 * tableCategoriesEmptyRows }}>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[self.state.rowsPerPage]}
                  component="div"
                  count={tableCategoriesTotalRows}
                  rowsPerPage={self.state.rowsPerPage}
                  page={self.state.pageCategories}
                  onChangePage={self.handleOnChangePageCategories}
                />
              </Fragment>
            )}
          </Paper>
        )}

        {tableKeywordsTotalRows > 0 && (
          <Paper elevation={0} className={classes.paperTable} square={false}>
            {pending && <Skeleton variant="rect" width="100%" height={118} animation="wave" />}
            {!pending && tableKeywordsTotalRows > 0 && (
              <Fragment>
                <TableContainer className={classes.tableContainer}>
                  <Table className={classes.tableDetails} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" colSpan={2} className={classes.tableCellLabelHeaderTitle}>
                          Keywords
                        </TableCell>
                      </TableRow>
                      {tableKeywordsFoundTotalRows > 0 && <Fragment>{tableKeywordsFoundRows}</Fragment>}
                      <TableRow>
                        <TableCell align="left" className={classes.tableCellLabelHeaderSubtitleDetails}>
                          Keyword
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellLabelHeaderSubtitleDetails}>
                          Score
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableKeywordsTotalRows > 0 && <Fragment>{tableKeywordsRows}</Fragment>}
                      {tableKeywordsTotalRows > 0 && tableKeywordsEmptyRows > 0 && (
                        <TableRow style={{ height: 18 * tableKeywordsEmptyRows }}>
                          <TableCell colSpan={2}></TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[self.state.rowsPerPage]}
                  component="div"
                  count={tableKeywordsTotalRows}
                  rowsPerPage={self.state.rowsPerPage}
                  page={self.state.pageKeywords}
                  onChangePage={self.handleOnChangePageKeywords}
                />
              </Fragment>
            )}
          </Paper>
        )}

        {tableLogTotalRows > 0 && (
          <Paper elevation={0} className={classes.paperTable} square={false}>
            {pending && <Skeleton variant="rect" width="100%" height={118} animation="wave" />}
            {!pending && tableLogTotalRows > 0 && (
              <Fragment>
                <TableContainer className={classes.tableContainer}>
                  <Table className={classes.tableDetails} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left" colSpan={6} className={classes.tableCellLabelHeaderTitle}>
                          Log
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" className={classes.tableCellLabelHeaderTitleLog}>
                          Process
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellLabelHeaderTitleLog}>
                          Action
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellLabelHeaderTitleLog}>
                          User
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellLabelHeaderTitleLog}>
                          Date
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableLogTotalRows > 0 && <Fragment>{tableLogRows}</Fragment>}
                      {tableLogTotalRows > 0 && tableLogEmptyRows > 0 && (
                        <TableRow style={{ height: 18 * tableLogEmptyRows }}>
                          <TableCell colSpan={4}></TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[self.state.rowsPerPage]}
                  component="div"
                  count={tableLogTotalRows}
                  rowsPerPage={self.state.rowsPerPage}
                  page={self.state.pageLog}
                  onChangePage={self.handleOnChangePageLog}
                />
              </Fragment>
            )}
          </Paper>
        )}
      </Fragment>
    );
  }
}

DetailIdentifySupplierJobs.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const selectedRow = state.IdentifySupplierJobsReducers.selectedRow;
  const selectedRowDetails = state.IdentifySupplierJobsReducers.selectedRowDetails;
  const pending = state.IdentifySupplierJobsReducers.pending;

  return {
    selectedRow,
    selectedRowDetails,
    pending,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(detailIdentifySupplierJobsStyle)(DetailIdentifySupplierJobs));